/**
 * Lazy-load and cache vtk.js modules used by the viewer.
 */

// VTK.js has TypeScript types but they're complex and auto-generated.
// We use `unknown` with type assertions to satisfy ESLint while maintaining
// the library's runtime type checking.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type VtkAny = any;

export type VtkModules = {
  vtkRenderWindow: unknown;
  vtkRenderer: unknown;
  vtkOpenGLRenderWindow: unknown;
  vtkInteractor: unknown;
  vtkInteractorStyle: unknown;
  vtkActor: unknown;
  vtkMapper: unknown;
  vtkPolyData: unknown;
  vtkPoints: unknown;
  vtkCellArray: unknown;
  vtkDataArray: unknown;
  vtkScalarBarActor: unknown;
};

let vtkCache: VtkModules | null = null;

export async function loadVtkModules(): Promise<VtkModules> {
  if (vtkCache) return vtkCache;

  await import('@kitware/vtk.js/Rendering/Profiles/Geometry');

  const [RW, Ren, GL, Int, Style, Actor, Mapper, PD, Pts, CA, DA, SBA] =
    await Promise.all([
      import('@kitware/vtk.js/Rendering/Core/RenderWindow'),
      import('@kitware/vtk.js/Rendering/Core/Renderer'),
      import('@kitware/vtk.js/Rendering/OpenGL/RenderWindow'),
      import('@kitware/vtk.js/Rendering/Core/RenderWindowInteractor'),
      import('@kitware/vtk.js/Interaction/Style/InteractorStyleTrackballCamera'),
      import('@kitware/vtk.js/Rendering/Core/Actor'),
      import('@kitware/vtk.js/Rendering/Core/Mapper'),
      import('@kitware/vtk.js/Common/DataModel/PolyData'),
      import('@kitware/vtk.js/Common/Core/Points'),
      import('@kitware/vtk.js/Common/Core/CellArray'),
      import('@kitware/vtk.js/Common/Core/DataArray'),
      import('@kitware/vtk.js/Rendering/Core/ScalarBarActor'),
    ]);

  vtkCache = {
    vtkRenderWindow: RW.default,
    vtkRenderer: Ren.default,
    vtkOpenGLRenderWindow: GL.default,
    vtkInteractor: Int.default,
    vtkInteractorStyle: Style.default,
    vtkActor: Actor.default,
    vtkMapper: Mapper.default,
    vtkPolyData: PD.default,
    vtkPoints: Pts.default,
    vtkCellArray: CA.default,
    vtkDataArray: DA.default,
    vtkScalarBarActor: SBA.default,
  };

  return vtkCache;
}
